import { ArrowDropDown } from '@mui/icons-material'
import { Skeleton } from '@mui/material'
import { getPublicCompressed } from '@toruslabs/eccrypto'
import axios from 'axios'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { CATEGORY_MENU_IMAGES } from '../../../constants/static'
import { useWeb3Auth } from '../../../services/web3auth'
import useAuthStore from '../../../store/authStore'
import useUploadStore from '../../../store/uploadStore'
import SearchBox from '../SearchBox'

const DesktopBottombar = ({
  currentCategory,
  currentQuery,
  setSearchCategory,
  parent,
}: any) => {
  const [searchBox, setSearchBox] = useState(false)
  const [loader, setLoader] = useState<boolean>(true)
  const [saltBalance, setSaltBalance] = useState<any>()
  const [maticBalance, setMaticBalance] = useState<any>()
  const [walletAddress, setWalletAddress] = useState<string>('')
  const [categoryOpen, setCategoryOpen] = useState<boolean>(false)
  const router = useRouter()
  const { setActiveStep, setCurrentCategory, setUploadAssetId } =
    useUploadStore()

  const [active, setActive] = useState('')

  const user_id = useAuthStore((state) => state.userInfo)

  // For getting user verified
  const [secretKey, setSecretKey] = useState<any>()
  const [idToken, setIdToken] = useState<any>()
  const [typeOfLogin, setTypeOfLogin] = useState<any>()

  const { getCategoryList, categoryList } = useUploadStore()
  const { setCurrentUser, setOpenLogginDetails } = useAuthStore()
  const { logout } = useWeb3Auth()

  const [category, setCategory] = useState('All Categories')
  let [userName, setUserName] = useState<string>('')
  let [userProfileImage, setUserProfileImage] = useState<string>('')
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const path = router.route
    if (path === '/') setActive('discover')
    else setActive(path.slice(1).split('/')?.[0])
  }, [category, active, router])

  useEffect(() => {
    getCategoryList()
    if (walletAddress) return
    let x = setInterval(function () {
      setLoader(false)
    }, 4000)
    return () => clearInterval(x)
  }, [])

  const {
    provider,
    getAccounts,
    getMaticBalance,
    getPrivateKey,
    isLoading,
    metaMaskSign,
  } = useWeb3Auth()

  async function getCredentials() {
    setLoader(true)
    const wallet = await localStorage.getItem('WalletAddress')
    if (wallet !== null && wallet !== undefined) {
      setUserName(wallet)
      setLoader(false)
    }
    const crendetials = await localStorage.getItem('openlogin_store')
    if (crendetials !== null && crendetials !== undefined) {
      const user = JSON.parse(crendetials)
      setOpenLogginDetails(JSON.parse(crendetials))
      setIdToken(user.idToken)
      setTypeOfLogin(user.typeOfLogin)
    }
    setLoader(false)
  }

  useEffect(() => {
    if (provider) {
      if (
        !user_id ||
        user_id == undefined ||
        !walletAddress ||
        walletAddress == undefined
      )
        return
      const config = { user: { uid: user_id } }
      // console.log('config', config)
      axios
        .post(
          'https://us-central1-test-69192.cloudfunctions.net/userAuth/getWallet',
          config
        )
        .then((res) => {
          // const data = res?.data?.data?.data
          if (res?.data?.data?.salt) {
            setSaltBalance(res?.data?.data?.salt)
          } else {
            setSaltBalance(0)
          }
        })
        .catch((e) => {
          console.log(e)
        })

      Object.assign(config, { wallet_address: walletAddress })
      // console.log('Data is', config)
      if (typeOfLogin == 'jwt') {
        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/userAuth/updateWallet',
            config
          )
          .then((res) => console.log(res))
          .catch((e) => console.log(e?.response?.data?.message))
      }
    }
  }, [user_id, provider, walletAddress])

  useEffect(() => {
    if (provider) {
      getAccounts().then(() => {
        const address = localStorage.getItem('WalletAddress')
        if (address !== null && address !== undefined) {
          setWalletAddress(address)
          // console.log(walletAddress)
        }
      })
      if (walletAddress != '' && !isLoading && !loader) {
        getMaticBalance().then((data) =>
          setMaticBalance((data / 1e18).toFixed(2))
        )
      }

      const adapter = localStorage.getItem('Web3Auth-cachedAdapter')

      // TODO:
      if (adapter == 'wallet-connect-v1') {
        const walletConnect = localStorage.getItem('walletconnect')
        if (walletConnect !== null && walletConnect !== undefined) {
          // console.log('Hello there', walletConnect)
          // console.log('walletconnect login flow ')
          metaMaskSign()
            .then((data) => {
              const uid = data?.data?.data?.wallet?.address
              if (uid != undefined) {
                setCurrentUser(uid)
                localStorage.setItem('uid', uid)
              }
            })
            .catch((e) => {
              console.log(e)
            })

          localStorage.setItem('signature', '1')
        }
      }
      const isSigned = localStorage.getItem('signature')
      if (adapter == 'metamask' && isSigned == '0') {
        // console.log('metamask login flow ')
        metaMaskSign()
          .then((data) => {
            const uid = data?.data?.data?.wallet?.address

            if (uid != undefined) {
              setCurrentUser(uid)
              localStorage.setItem('uid', uid)
            }
          })
          .catch((e) => {
            // console.log(e)
          })

        localStorage.setItem('signature', '1')
      }

      if (typeOfLogin == 'discord') {
        // console.log('Only Discord Login goes here')
        // localStorage.setItem('uid', walletAddress)
        getPrivateKey().then((data) => {
          // console.log(data)
          setSecretKey(data)
        })

        let app_pub_key

        if (secretKey != undefined) {
          app_pub_key = getPublicCompressed(
            Buffer.from(secretKey.padStart(64, '0'), 'hex')
          ).toString('hex')
        }
        // console.log('secret key', secretKey)
        // console.log('app_pub_key', app_pub_key)

        const verifierData = {
          app_pub_key: app_pub_key,
          idToken: idToken,
          address: walletAddress,
          name: userName,
        }
        // console.log(verifierData)

        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/app/getverified-social',
            verifierData
          )
          .then((res) => {
            // console.log('response for discode', res)
            setCurrentUser(walletAddress)
            localStorage.setItem('uid', walletAddress)
          })
          .catch((e) => {
            // console.log(e)
          })
      }

      if (typeOfLogin == 'jwt' && localStorage.getItem('uid') === null) {
        const crendetials = localStorage.getItem('openlogin_store')
        if (crendetials !== null && crendetials !== undefined) {
          const user = JSON.parse(crendetials)
          // localStorage.setItem('uid', user.verifierId)
          const authToken = user.oAuthIdToken

          const config = {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
          const body = {
            idToken: authToken,
          }
          // console.log(config)
          axios
            .post(
              'https://us-central1-test-69192.cloudfunctions.net/app/valid',
              body,
              config
            )
            .then(async (res) => {
              // console.log('response', res)
              // console.log('result', JSON.parse(res.data.data.token))
              const result = JSON.parse(res.data.data.token)
              setCurrentUser(result.uid)
              localStorage.setItem('uid', result.uid)
            })
            .catch((e) => {
              console.log('error occured', e)
            })
        }
      }

      if (!userName || !userProfileImage) {
        getCredentials()
      }
    }
  }, [userName, loader, getAccounts, provider, walletAddress])

  const openMenu = (type: string) => {
    if (type === 'open') {
      setMenu(true)
      document.body.style.overflow = 'hidden'
    } else {
      setMenu(false)
      document.body.style.overflow = 'auto'
    }
  }

  return (
    <div className="ml-auto hidden h-12 border-b-2 border-gray-800 md:grid">
      <div className="ml-8 grid-cols-4 md:grid">
        <div className="flex flex-row items-center justify-center">
          <Link href="/">
            <button
              className={`group flex flex-row items-center justify-center border-b-2 px-3 py-3 hover:border-primary ${
                active === 'discover' || active === 'trending'
                  ? 'border-b-2 border-primary'
                  : 'border-transparent'
              }`}
            >
              <Image
                width={18}
                height={18}
                alt="discover"
                className={`${
                  active === 'discover' || active === 'trending'
                    ? 'grayscale-0'
                    : 'grayscale'
                } group-hover:grayscale-0`}
                src="/icons/explore.svg"
              />
              <span
                className={`group-hover:text-yellow-200 ${
                  active === 'discover' || active === 'trending'
                    ? 'text-primary'
                    : 'text-white'
                }  ml-2 font-oswaldregular text-sm uppercase`}
              >
                Discover
              </span>
            </button>
          </Link>
          <div className="group ">
            <button
              className={`group ml-2 flex flex-row items-center justify-center border-b-2 px-3 py-3 group-hover:border-primary ${
                active === 'categories'
                  ? 'border-b-2 border-primary'
                  : 'border-transparent'
              }`}
            >
              <Image
                width={18}
                height={18}
                alt="categories"
                className={`${
                  active === 'categories' ? 'grayscale-0' : 'grayscale'
                } group-hover:grayscale-0`}
                src="/icons/categories.svg"
              />
              <span
                className={`group-hover:text-yellow-200 ${
                  active === 'categories' ? 'text-primary' : 'text-white'
                } ml-2 font-oswaldregular text-sm uppercase`}
              >
                Categories
              </span>
              <ArrowDropDown
                className={`${
                  active === 'categories' ? 'text-primary' : 'text-white'
                } h-5 w-5 group-hover:text-primary `}
              />
            </button>
            <div className="pointer-events-none absolute z-50 grid w-4/5 -translate-y-4 transform grid-cols-4 items-center justify-center gap-4 bg-black p-2 opacity-0 backdrop-blur-3xl transition-all duration-300 ease-in group-hover:pointer-events-auto group-hover:translate-y-0 group-hover:opacity-100">
              {categoryList?.length
                ? categoryList.map((category, index) => (
                    <Link
                      key={index}
                      href={
                        index === 0
                          ? '/categories'
                          : `/categories/${category.key}`
                      }
                    >
                      <div className="grid w-full cursor-pointer grid-cols-3  items-center justify-center gap-4 bg-white/10 px-4 transition-all hover:bg-white/20 ">
                        <div className="col-span-1">
                          <Image
                            src={
                              CATEGORY_MENU_IMAGES[category.key] ||
                              '/3dmodal.png'
                            }
                            alt="category"
                            width={60}
                            height={60}
                          />
                        </div>
                        <div className="col-span-2 flex flex-col items-start text-white ">
                          <span className="font-oswaldregular text-lg">
                            {category?.name}
                          </span>
                          <span className="w-11/12 overflow-hidden truncate font-oswaldregular text-[12px] opacity-60">
                            {category?.description?.[0]}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))
                : [1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
                    <Skeleton
                      key={index}
                      variant="rectangular"
                      animation="wave"
                      className="mr-1 mt-1 h-16 w-[24%] bg-gray-400/20"
                    />
                  ))}
            </div>
          </div>
          <Link href="/upload">
            <button
              className={`group ml-2 flex flex-row items-center justify-center border-b-2 px-3 py-3 hover:border-primary ${
                active === 'upload'
                  ? 'border-b-2 border-primary'
                  : 'border-transparent'
              }`}
              id="upload"
              onClick={() => {
                setActiveStep(-1)
                setUploadAssetId('')
                setCurrentCategory(undefined)
              }}
            >
              <Image
                width={18}
                height={18}
                alt="upload"
                className={`${
                  active === 'upload' ? 'grayscale-0' : 'grayscale'
                } group-hover:grayscale-0`}
                src="/icons/upload.svg"
              />
              <span
                className={`group-hover:text-yellow-200 ${
                  active === 'upload' ? 'text-primary' : 'text-white'
                } ml-2 font-oswaldregular text-sm uppercase`}
              >
                Upload
              </span>
            </button>
          </Link>
        </div>
        <SearchBox
          key={String(Math.random()).slice(2, 10)}
          currentCategory={currentCategory}
          currentQuery={currentQuery}
          setSearchCategory={setSearchCategory}
          parent={parent}
        />

        {provider ? (
          <div className="flex flex-row justify-end ">
            <Link href="/myasset">
              <button
                className={`group flex flex-row items-center justify-center border-b-2 px-3 py-3 hover:border-primary ${
                  active === 'myasset'
                    ? 'border-b-2 border-primary'
                    : 'border-transparent'
                }`}
                id="myasset"
              >
                <span
                  className={`group-hover:text-yellow-200 ${
                    active === 'myasset' ? 'text-primary' : 'text-white'
                  }  font-oswaldregular text-sm uppercase`}
                >
                  My Asset
                </span>
              </button>
            </Link>

            {/* {Adding Provider to check the user is logged in or not before showing tokens} */}

            <div className="-mr-4 ml-10 hidden -skew-x-12 transform flex-row items-center justify-center border-2 border-green-700 bg-gray-800 px-6 py-1 text-white md:flex">
              <div className="flex skew-x-12 transform flex-row items-center justify-center">
                <Image
                  width={28}
                  height={24}
                  alt="salt"
                  src="/icons/salt.png"
                />
                <span className="font-spaceMonoregular mr-2 ml-2 text-sm">
                  {isNaN(saltBalance) ? '...' : saltBalance}
                </span>
              </div>
              <div className="flex skew-x-12 transform flex-row items-center justify-center">
                <Image
                  width={24}
                  height={24}
                  alt="matic"
                  src="/icons/polygon.png"
                />
                <span className="font-spaceMonoregular mr-2 ml-2 text-sm">
                  {isNaN(maticBalance) ? '...' : maticBalance}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default DesktopBottombar
